<div class="container">
  <div class="text">
    {{ 'custom-snackbar-error.error-message' | translate }}
  </div>
  <button (click)="copyError()" color="primary" mat-raised-button>
    {{ 'custom-snackbar-error.copy-button' | translate }}
  </button>
</div>
